export default "__VITE_ASSET__DN0vxLp5__"